module.exports = __webpack_public_path__ + "img/prot-300.a7ab5578.png";